import { ButtonProps, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { SenecFunctionalIconButton } from "src/components/button/senec-functional-button/SenecFunctionalIconButton";
import { ReactElement } from "react";
import { CloseIcon, ChevronLeftIcon } from "src/foundations/icons";

export const DialogHeader = ({
    icon,
    title,
    onClose,
    onReturn,
}: {
    icon?: ReactElement;
    title?: string;
    onClose: () => void;
    onReturn?: () => void;
}) => (
    <Stack display={"flex"} direction={"row"} alignItems={"center"} justifyContent={"space-between"} gap="1rem">
        {onReturn && <ReturnButton onClick={onReturn} />}
        {icon}
        {title && (
            <Typography
                data-testid={"desktop-title"}
                variant="h4"
                sx={{ display: "-webkit-box", overflow: "hidden", WebkitBoxOrient: "vertical", WebkitLineClamp: 1 }}
            >
                {title}
            </Typography>
        )}
        <CloseButton onClick={onClose} />
    </Stack>
);

const CloseButton = ({ onClick }: ButtonProps) => (
    <Box>
        <SenecFunctionalIconButton data-testid={"close-btn-id"} level={"secondary"} onClick={onClick}>
            <CloseIcon />
        </SenecFunctionalIconButton>
    </Box>
);

const ReturnButton = ({ onClick }: ButtonProps) => (
    <Box>
        <SenecFunctionalIconButton data-testid={"return-btn-id"} level={"secondary"} onClick={onClick}>
            <ChevronLeftIcon />
        </SenecFunctionalIconButton>
    </Box>
);
